module.exports = __webpack_public_path__ + "img/logo.b6c82d1b.png";